import React, { useState, useEffect, Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import merge from 'deepmerge';
import _ from 'lodash';
import { fetchSmartPromotions, updateSmartPromotion, createSmartPromotion } from '../../../../actions';
import { getCurrentRestaurant, getCurrentChain } from '../../../../selectors';
import SmartPromotion from './SmartPromotion';
import { smartPromotionsMetadata } from './smartPromotionsMetadata';
import MenusPicker from '../../../app-business/menu-editor/MenusPicker';
import { Header } from 'semantic-ui-react';
import i18next from 'i18next';

import './SmartPromotions.scss';

const SmartPromotions = (props) => {
    const dispatch = useDispatch();
    const [menuId, setMenuId] = useState(null);
    const branch = useSelector(getCurrentRestaurant);
    const chain = useSelector(getCurrentChain);
    const [smartPromotions, setSmartPromotions] = useState(null);

    const convertToDictionary = (upsells) => {
        return upsells.reduce((dictionary, currElement) => {
            dictionary[currElement.type] = currElement;
            return dictionary;
        }, {});
    };

    const handleUpdateSmartPromotion = (upsell) => {
        const { imgUrl, title, description, Settings, ...upsellToSave } = upsell;

        if (!_.isEqual(upsellToSave, smartPromotions[upsellToSave.type])) {
            setSmartPromotions({ ...smartPromotions, [upsellToSave.type]: upsellToSave });
            dispatch(upsellToSave.id ? updateSmartPromotion(upsellToSave, branch && branch.id) : createSmartPromotion(upsellToSave, branch && branch.id));
        }
    };

    useEffect(() => {
        if (!menuId) {
            if (branch) {
                setMenuId(branch.menuId);
            } else if (!chain) {
                return props.history.push('/');
            }
        }
    }, []);

    useEffect(() => {
        if (menuId && !smartPromotions) {
            dispatch(fetchSmartPromotions(menuId, branch && branch.id, (smartPromotions => setSmartPromotions(convertToDictionary(smartPromotions)))));
        }
    }, [menuId]);

    return (
        <Fragment>
            {props.location.pathname.startsWith('/chain') && <MenusPicker open={!menuId}  route={'smartPromotions'} handleMenuPicked={setMenuId}/>}
            <Header.Content className="page-header">{i18next.t('smartPromotionsPage.title')}</Header.Content>
            <Header.Content className="page-sub-header">{i18next.t('smartPromotionsPage.description')}</Header.Content>
            {smartPromotions && (
                <div style={{ padding: 20 }} className="pi-smart-promotions">
                    {Object.keys(smartPromotionsMetadata).map((smartPromotionType, index) => {
                        const smartPromotion = merge(smartPromotionsMetadata[smartPromotionType], smartPromotions[smartPromotionType] || { menuId, type: smartPromotionType });

                        return (
                            <SmartPromotion 
                                key={index}
                                {...props}
                                upsell={smartPromotion}
                                handleUpdateSmartPromotion={handleUpdateSmartPromotion}
                            />
                        );
                    })}
                </div>
        )}
        </Fragment>
    );
};

SmartPromotions.propTypes = {
    chain: PropTypes.object,
    history: PropTypes.object,
    location: PropTypes.object,
    branchIdForOverride: PropTypes.string
};

export default SmartPromotions;